import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CfetBaseComponent } from '../../cfet-core';
import { environment } from './../../../environments/environment';

@Component({
    selector: 'app-customer-inactivity-utf-modal',
    templateUrl: './customer-inactivity-utf-modal.component.html',
    styleUrls: ['./customer-inactivity-utf-modal.component.scss'],
    standalone: false
})
export class CustomerInactivityUtfModalComponent extends CfetBaseComponent {

  url = '';
  @Input() openModal: string;
  @Output() closeInactivityModal = new EventEmitter<any>();

  constructor() { super(); }


  close(event: any, modalAction: string) {
    if (event.key === 'Enter' || event.type === 'click' ||
      event.keyCode === 13 || event.type === 'clicked outside') {
      this[modalAction] = 'close';
      this.closeInactivityModal.emit('modalClose');
    }
  }

  keepWorking(event, modalAction: string) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      this[modalAction] = 'close';
      this.closeInactivityModal.emit('modalClose');
    }
  }

  closeApplication(event, modalAction: string) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      this[modalAction] = 'close';
      this.closeInactivityModal.emit('modalClose');
      if (sessionStorage.getItem('returnUrl') && Object.keys(sessionStorage.getItem('returnUrl').length !== 0)) {
        this.url = JSON.parse(sessionStorage.getItem('returnUrl'));
        if (this.url && this.url.indexOf('?') === -1) {
          this.redirectUrl(this.url + '?fnStatus=eligible');
        } else {
          this.redirectUrl(this.url + '&fnStatus=eligible');
        }
        sessionStorage.clear();
      } else {
        // Redirect to the landing page
        window.location.href = environment.att_Utf_Path;
        window.scrollTo(0, 0);
        sessionStorage.clear();
      }
    }
  }

  redirectUrl(url) {
    if (this.isEncoded(url)) {
      window.location.href = decodeURIComponent(url);
    } else {
      window.location.href = url;
    }
  }

  isEncoded(url) {
    if (url != '') {
      return url !== decodeURIComponent(url);
    }
  }

}
